/* Knight kiwi variant — holding a pixel shield. */

import type { KiwiPalette } from "../kiwiPalettes";

export function renderKnight(p: KiwiPalette) {
  return (
    <>
      {/* Body */}
      <path d="M12 6H20V8H24V10H26V18H24V22H20V24H12V22H8V18H6V10H8V8H12V6Z" fill={p.body} />
      {/* Highlight */}
      <rect x="20" y="10" width="2" height="2" fill={p.highlight} opacity={0.3} />
      {/* Beak */}
      <path d="M4 12H6V14H4V12ZM2 14H4V16H2V14ZM2 16H4V18H2V16ZM4 18H6V20H4V18Z" fill={p.beak} />
      {/* Tuft */}
      <path d="M10 4H12V6H10V4ZM8 2H10V4H8V2ZM12 2H14V4H12V2Z" fill={p.body} />
      {/* Eye */}
      <rect x="10" y="10" width="6" height="6" fill={p.eyeBg} />
      <rect x="12" y="12" width="2" height="2" fill={p.pupil} />
      {/* Shield */}
      <path d="M26 8H30V10H32V16H30V20H28V22H26V8Z" fill={p.accent} opacity={0.45} />
      <path d="M28 10H30V14H28V10Z" fill={p.eyeBg} opacity={0.2} />
      {/* Feet */}
      <path d="M12 24H14V28H12V24ZM10 28H16V30H10V28Z" fill={p.body} />
      <path d="M18 24H20V28H18V24ZM16 28H22V30H16V28Z" fill={p.body} />
    </>
  );
}
